import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import registerService from '../services/registerService';
import './Register.css';
import Swal from 'sweetalert2';
import Header from './Header';


const Register = () => {
  const [formData, setFormData] = useState({
    dni: '',
    name: '',
    last_name: '',
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dniRegex = /^\d{7,10}$/;

    const newErrors = {};

    // Validating dni
    if (!formData.dni || !dniRegex.test(formData.dni)) {
      newErrors.dni = 'Por favor, ingrese una cédula válida (de 7 a 10 dígitos).';
    }

    if (Object.keys(newErrors).length === 0) {
      try {
        await registerService.register(formData);

        Swal.fire({
          title: '¡registro exitoso!',
          icon: "success",
          text: 'tu registro ha sido completado con éxito. ya puede cerrar esta ventana',
          confirmButtonText: 'volver',
          customClass: {
            confirmButton: 'btn btn-aviancaa',
          },
        }).then((result) => { });

        // setSuccessMessage('¡Registro exitoso! Ahora puede iniciar sesión.');
        setFormData({
          dni: '',
          last_name: '',
          name: '',
        });
      } catch (err) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'esta cédula ya existe',
          customClass: {
            title: "text-center"
          },
          showConfirmButton: false, // Mostrar el botón de confirmación
          timer: 2500,
          timerProgressBar: true,
        });
        setErrors(err);
      }
    } else {
      setErrors(newErrors);
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <>

      {/* vista para celular */}
      <div className="d-block d-md-none d-lg-none d-xl-none external-container d-flex justify-content-center align-items-center vh-100">
        <div className="container d-flex justify-content-center align-items-center flex-column">
          <div className="col-12 m-0 p-0">
            <div className="col-12 d-flex justify-content-center align-items-center">
              <img src="./aviancaLogo.png" className="container-logo" alt="logo" />
            </div>
          </div>
          <div className='container d-flex justify-content-center align-items-center mt-5'>
            <div className='row'>
              <h1 className='text-white text-center mb-0 mt0 tolowercase'>¡Bienvenido!</h1>
              <h1 className='text-white text-center mb-0 mt0 tolowercase mt-3'>¡Inscríbete aquí!</h1>
              <div className="triangle-text mt-2">
                <p className="text-white text-center" style={{ marginBottom: '-5px' }}>Descubre con tu grito de gol a cuál</p>
                <p className="text-white text-center" style={{ marginBottom: '-5px' }}>de los +80 destinos puedes llegar.</p>
              </div>
            </div>
          </div>
          <div className="col-12 m-0 p-0 mb-1">
            <div className="d-flex justify-content-center align-items-center flex-column">
              <div className="col-11 col-lg-8 d-flex justify-content-center align-items-center flex-column">
                <div className="form-container register-container text-center text-white mt-5">

                  {successMessage ? (
                    <div>
                      <p className="m-0 p-0">{successMessage}</p>
                    </div>
                  ) : (

                    <form className="register-form" onSubmit={handleSubmit}>
                      <div className="form-group text-start">
                        <label className='h6 lowercase text-danger'>Nombre</label>
                        <input
                          type="text"
                          className="form-container-input"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        {errors.name && <p className="error-message m-0 p-0 text-white Bebas-Neue">{errors.name}</p>}
                      </div>


                      {/* apellido */}
                      <div className="form-group text-start">
                        <label className='h6 lowercase text-danger'>Apellido</label>
                        <input
                          type="text"
                          className="form-container-input"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          required
                        />
                        {errors.last_name && <p className="error-message m-0 p-0 text-white Bebas-Neue">{errors.last_name}</p>}
                      </div>

                      {/* cedula */}
                      <div className="form-group text-start">
                        <label className='h6 lowercase text-danger'>Cédula</label>
                        <input
                          type="text"
                          className="form-container-input"
                          name="dni"
                          value={formData.dni}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="d-flex justify-content-center align-items-center">
                        <button type="submit" className="form-container-button w-75 lowercase">regístrese</button>
                      </div>
                    </form>
                  )}
                  {errors.non_field_errors && <p className="error-message m-0 p-0 text-white Bebas-Neue">{errors.non_field_errors}</p>}
                </div>
              </div>
            </div>
            <div className='row mt-5'>
              <h1 className='text-white text-center mb-0 mt0 tolowercase'>Prepárate para Jugar</h1>
            </div>
          </div>
        </div>

        {/* footer mobile */}
        <footer className="d-block d-md-none d-lg-none d-xl-none col-12 mt-auto">
          <div className="d-flex justify-content-between align-items-center text-white mb-2">
            <div className='mx-4 mb-3'>
              <img src="./Logo-SuperTransporte.png" style={{ width: '100%' }} alt="logo" />
            </div>
            <div className='text-end mx-4 mb-3'>
              <img src="./Logo-Footer-2.png" style={{ width: '70%' }} alt="logo" />
            </div>
          </div>
        </footer>
      </div>



      {/* vista pc */}
      <div className="d-none d-md-flex d-lg-flex d-xl-flex external-container d-flex justify-content-center align-items-center vh-100">
        <Header />
        <div className="container d-flex justify-content-center align-items-center flex-column mt-5">

          <div className="col-12 m-0 p-0 m-t-0 mb-3">
            <div className="col-12 d-flex justify-content-center align-items-center mt-5">
              <div className="d-flex justify-content-center align-items-center flex-lg-row flex-column mt-5">
                <div className="col-12 col-lg-5 mx-3 d-flex justify-content-center align-items-center flex-column mt-5">
                  <h1 className="title-login-sesion Bebas-Neue">!Registrate aqui¡</h1>
                  <form className="login-form w-100 d-flex justify-content-center align-items-center flex-column" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      className="form-container-input text-center"
                      name="name"
                      placeholder='Ingresa tu nombre'
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />

                    <input
                      type="text"
                      className="form-container-input text-center"
                      name="last_name"
                      placeholder='Ingresa tu apellido'
                      value={formData.last_name}
                      onChange={handleChange}
                      required
                    />

                    <input
                      type="text"
                      className="form-container-input text-center"
                      name="dni"
                      placeholder='Ingresa tu cédula'
                      value={formData.dni}
                      onChange={handleChange}
                      required
                    />
                    <button type="submit" className="form-container-button w-70 lowercase">Regístrese</button>
                  </form>
                </div>
                <div className="col-12 col-lg-6 mx-3 d-flex justify-content-center align-items-center">
                  <img src="./aviancaLogo.png" className="container-logo-events" alt="avianca" />
                </div>
              </div>
            </div>
          </div>
        </div>



        <footer className="d-none d-md-block d-lg-block d-xl-block col-12 mt-auto col-12 mt-auto bg-transparent">
          <div className="d-flex justify-content-between align-items-center text-white mb-2">
            <div className='mx-4 mb-3'>
              <img src="./Logo-SuperTransporte.png" style={{ width: '85%' }} alt="logo" />
            </div>
            <div className='text-end mx-4 mb-3'>
              <img src="./Logo-Footer-2.png" style={{ width: '35%' }} alt="logo" />
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Register;
